import { fetchPost } from "~/utils/fetch";
import { Auth } from "../dto/routes/AuthRoute";

type TOutputDto = Auth.PostAuthSigninRequestsControllerHandle.ResponseBody;

export const postAuthSignInRequests = () =>
  fetchPost<TOutputDto>({
    url: `/auth/sign-in/requests`,
  });
